import { createAsyncAction, createAction } from "typesafe-actions";
import emailSchedulerConstants from "store/features/emailScheduler/overview/overview.constants";
import { CreateEmailSchedulerRuleForm } from "validation/components/EmailScheduler/emailSchedulerFormRules";

const {
    FETCH_SCHEDULER_CONFIGS_REQUEST,
    FETCH_SCHEDULER_CONFIGS_SUCCESS,
    FETCH_SCHEDULER_CONFIGS_FAILED,
    DELETE_SCHEDULER_RULE_REQUEST,
    DELETE_SCHEDULER_RULE_SUCCESS,
    DELETE_SCHEDULER_RULE_FAILED,
    TOGGLE_EDIT,
} = emailSchedulerConstants;

export const fetchSchedulerOverviewConfigs = createAsyncAction(
    FETCH_SCHEDULER_CONFIGS_REQUEST,
    FETCH_SCHEDULER_CONFIGS_SUCCESS,
    FETCH_SCHEDULER_CONFIGS_FAILED
)<void, { emailConfigurations: CreateEmailSchedulerRuleForm[] }, ErrorHandler>();

export const deleteSchedulerRule = createAsyncAction(
    DELETE_SCHEDULER_RULE_REQUEST,
    DELETE_SCHEDULER_RULE_SUCCESS,
    DELETE_SCHEDULER_RULE_FAILED
)<string, void, ErrorHandler>();

export const editSchedulerRule = createAction(TOGGLE_EDIT, (id: string) => {
    return {
        id,
        isCopy: false,
    };
})();

export const copySchedulerRule = createAction(TOGGLE_EDIT, (id: string) => {
    return {
        id,
        isCopy: true,
    };
})();
